const svgPaths = {
  p1b9dbe00: 'M0 0 H100 V100 H0 Z', // Placeholder path
  p1390bb70: 'M0 0 H100 V100 H0 Z', // Placeholder path
};
export default svgPaths;
